"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
function useForm(data) {
    return (0, vue_1.reactive)({
        ...data,
        errors: {},
        resetErrors() {
            this.errors = {};
        },
    });
}
exports.default = useForm;
